// 教學頁的課程連結與轉換事件（2026-10-16）。
//
// 兩種去處：
// 1. Hahow 舊課（三門錄播課）：一律走講師專屬網址 hahow.in/cr/<uniquename>。分潤看的是「從專屬網址進站」
//    （合約第 9 條：經講師管道 90%、其他 50%，從最近一次經專屬網址進站起算 7 天），所以不准直接連 /courses/<id>。
//    /cr/ 網址後面帶 utm 參數會原樣帶到課程頁、推薦紀錄照寫（2026-10-16 課程站研究實測）。
// 2. 新媒體藝術全景課：導到課程網站首頁（哲宇 2026-10-16 經課程首頁那條線交代）。課程首頁本身是導流頁，
//    每顆報名鈕都是 CR 加來源參數，還有這一期的作品、人數與補課路線；課程站的 GA4 會留 utm_*，分得出官網帶過去的人。
//
// utm：source＝cheyuwu.com、medium＝referral、campaign＝teaching-<頁面位置>、content＝<課程代號>-<語系>。
// rel 只放 noopener，不放 noreferrer：留著來源網域（對方報表看得到），分潤不受影響。
//
// 事件（src/runtime/analytics.mjs，只在正式網域送）：
//   course_impression：課程卡或按鈕第一次有一半進入視窗（同一頁同一個位置只送一次）
//   course_click：按下課程連結
// 參數都是公開事實：course（課程代號）、platform（hahow／course-site／monolab）、placement（頁面位置）、lang。
// 全站的 outbound_click 仍會照送（App.vue），它的 link_url 會剝掉 query，所以位置要靠 course_click 的 placement 才分得出來。
import { trackEvent } from '../../runtime/analytics.mjs'

export const UTM = { source: 'cheyuwu.com', medium: 'referral', campaignPrefix: 'teaching-' }

// TD 課程站（2026-10-18）：搜尋／官網 → TD 課程站 → 開課快手結帳。全站只有這一處寫它的網址，之後要換只改這裡
// （scripts/test-td-funnel.mjs 會擋別處直接寫網址）。新手指南在 /guide。
export const TD_COURSE_SITE = 'https://touchdesigner.course.monolab.world'
export const TD_COURSE_GUIDE = TD_COURSE_SITE + '/guide'
const EDU = 'https://education.monolab.world/courses/'
// 官網各處的 TD 去處。via 'course-site'＝導到課程網站（courseBase 取 href）；其餘走 platform／url。
// 首頁教學區的 data 用 key（site／workshop／livestream）指到這裡，不在 JSON 裡寫網址。
export const TD_COURSES = {
  guide: { slug: 'td-site', via: 'course-site', platform: 'course-site', href: TD_COURSE_GUIDE },
  site: { slug: 'td-site', via: 'course-site', platform: 'course-site', href: TD_COURSE_SITE + '/' },
  essentials: { slug: 'td-beginners', platform: 'monolab', url: EDU + 'beginners-class' },
  primer: { slug: 'td-basic', platform: 'monolab', url: EDU + 'basic' },
  workshop: { slug: 'td-workshop', platform: 'monolab', url: EDU + 'workshop' },
  // 直播挑戰第一集（YouTube）；官網時間軸、課程總站也用這一集當入口
  livestream: { slug: 'td-livestream', platform: 'youtube', url: 'https://www.youtube.com/watch?v=JfAAxnspHGk' },
}

// 這門課從官網出去的網址（全景課＝課程網站，Hahow 舊課＝CR，MONOLAB 平台＝原網址）
export const courseBase = (course) => (course.via === 'course-site' ? course.href : course.platform === 'hahow' ? course.cr : course.url || course.href)
export const coursePlatform = (course) => (course.via === 'course-site' ? 'course-site' : course.platform)

// opts.campaign／opts.content：覆寫 utm_campaign（預設 teaching-<位置>）與 utm_content（預設 <課程代號>-<語系>）。
// TD Daily 頁底的課程卡用它：utm_campaign=td-daily、utm_content=<作品 slug>。
export function courseHref(course, placement, lang = 'zh', opts = {}) {
  const base = courseBase(course)
  if (!base) return ''
  const u = new URL(base)
  u.searchParams.set('utm_source', UTM.source)
  u.searchParams.set('utm_medium', UTM.medium)
  u.searchParams.set('utm_campaign', opts.campaign || UTM.campaignPrefix + placement)
  u.searchParams.set('utm_content', opts.content || `${course.slug}-${lang}`)
  return u.toString()
}

export const trackCourseClick = (course, placement, lang) =>
  trackEvent('course_click', { course: course.slug, platform: coursePlatform(course), placement, lang })

// 進視窗一半才算看到；每個 (course, placement) 一頁只送一次
export function observeImpressions(root, lookup, lang) {
  if (typeof IntersectionObserver !== 'function' || !root) return () => {}
  const seen = new Set()
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (!e.isIntersecting) continue
      const el = e.target, key = el.dataset.course + '|' + el.dataset.placement
      io.unobserve(el)
      if (seen.has(key)) continue
      const course = lookup(el.dataset.course)
      if (!course) continue
      seen.add(key)
      trackEvent('course_impression', { course: course.slug, platform: coursePlatform(course), placement: el.dataset.placement, lang })
    }
  }, { threshold: 0.5 })
  root.querySelectorAll('[data-course][data-placement]').forEach((el) => io.observe(el))
  return () => io.disconnect()
}
